import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

export const organizersStoreSelector = (state: RootState) => state.organizers;

export const selectActiveOrganizerPlans = (tournamentId: number) =>
  createSelector([organizersStoreSelector], (state) => state.plans.byOwnerId[tournamentId]);

export const selectPlansList = createSelector([organizersStoreSelector], (state) => state.plans.list);
